import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useNavVariant } from "./utils/navigation/useNavVariant";
import { ProtectedRoute } from "./components/authentication/ProtectedRoute";

import NavBar from "./components/navigation/NavBar";
import MDNavBar from "./components/navigation/MDNavBar";
import ForgotPasswordRequest from "./components/authentication/ForgotPasswordRequest";
import ResetPassword from "./components/authentication/ResetPassword";

import { useAuth } from "./context/AuthContext";
import AdminPage from "./pages/AdminPage";

// Lazy pages
const LandingPage = lazy(() => import("./pages/LandingPage"));
const AuthPage = lazy(() => import("./pages/AuthPage"));
const SimpleVideoViewer = lazy(() => import("./pages/SimpleVideoViewer"));

export default function App() {
  const { user, claims } = useAuth();
  const location = useLocation();
  const role = claims?.role;

  const isAdmin =
    ["monitor", "principal_investigator", "chief_investigator"].includes(
      role,
    ) || user?.email === "bdruce@electronrx.com";

  const navVariant = useNavVariant(); // 'main' | 'landing'
  const isVideosRoute = location.pathname === "/videos";

  return (
    <div className="h-[100dvh] flex flex-col typography relative ">
      {navVariant === "main" ? <NavBar /> : <MDNavBar />}

      <div
        className={`min-h-0 flex-1 flex md:items-start md:justify-center px-4 pb-4 ${
          isVideosRoute ? "overflow-hidden" : "overflow-y-scroll"
        }`}
      >
        <Suspense fallback={<div className="m-auto">Loading…</div>}>
          <Routes>
            {/* ---------- Public routes ---------- */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth/*" element={<AuthPage />} />
            <Route
              path="/auth/forgot-password"
              element={<ForgotPasswordRequest />}
            />
            <Route path="/auth/reset-password" element={<ResetPassword />} />

            {/* New viewer */}
            <Route
              path="/videos"
              element={
                <ProtectedRoute>
                  <SimpleVideoViewer />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  {isAdmin ? <AdminPage /> : <Navigate to="/videos" replace />}
                </ProtectedRoute>
              }
            />

            {/* ---------- Fallback ---------- */}
            <Route path="*" element={<Navigate to={"/"} replace />} />
          </Routes>
        </Suspense>
      </div>

      <div className="muted-text flex flex-row justify-between px-1 pb-1">
        <p>© 2026, electronRx Ltd</p>
        <p>Cambridge, UK</p>
      </div>
    </div>
  );
}
